
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/benefits",
      function () {
        return require("private-next-pages/benefits/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/benefits"])
      });
    }
  